import { StringContext } from '../../core/StringContext';
import { StringData } from '../../core/StringData';
import { StringModule } from '../../core/StringModule';
import { StringScrollbarHorizontal } from './StringScrollbarHorizontal';
import { StringScrollbarVertical } from './StringScrollbarVertical';

export class StringScrollbar extends StringModule {
  private scrollbar: any;
  private thumb: any;
  private scrollTimeout: any;

  private isDragging = false;
  private scrollMode: 'smooth' | 'disable' | 'default' = 'smooth';

  private mouseUpEventBind: any;
  private mouseDownEventBind: any;
  private mouseMoveEventBind: any;

  private scrollbarState: any;
  private scrollbarStateHorizontal: any;
  private scrollbarStateVertical: any;

  constructor(context: StringContext) {
    super(context)

    this.mouseUpEventBind = this.mouseUpEvent.bind(this);
    this.mouseDownEventBind = this.mouseDownEvent.bind(this);
    this.mouseMoveEventBind = this.mouseMoveEvent.bind(this);
  }
  destructor(): void {
    document.removeEventListener('mouseup', this.mouseUpEventBind);
    this.thumb.removeEventListener('mousedown', this.mouseDownEventBind);
    document.removeEventListener('mousemove', this.mouseMoveEventBind);
  }

  onInit(): void {
    this.createScrollbar();
    this.updateThumb();
    this.addCustomStyles();
    document.addEventListener('mouseup', this.mouseUpEventBind);
    this.thumb.addEventListener('mousedown', this.mouseDownEventBind);
    document.addEventListener('mousemove', this.mouseMoveEventBind);
    document.documentElement.classList.add(`-no-scrollbar`);
  }

  onScroll(data: StringData): void {
    this.updateThumb();
    this.showScrollbar();
    this.hideScrollbar();
  }

  onResize(): void {
    this.scrollbarState.onResize();
  }

  private addCustomStyles() {
    const style = document.createElement('style');
    style.textContent = `
          ::-webkit-scrollbar {
            display: none;
            width: 0;
            height: 0;
            -webkit-appearance: none;
          }
          body {
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
          }
          .-without-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .-without-scrollbar {
              -ms-overflow-style: none; /* IE and Edge */
              scrollbar-width: none; /* Firefox */
          }
      `;
    document.head.appendChild(style);
  }

  private createScrollbar() {
    this.scrollbar = document.createElement('div');
    this.scrollbar.classList.add('scrollbar');
    this.thumb = document.createElement('div');
    this.thumb.classList.add('thumb');
    this.scrollbar.appendChild(this.thumb);
    document.body.appendChild(this.scrollbar);

    this.scrollbarStateHorizontal = new StringScrollbarHorizontal(this.data, this.scrollbar, this.thumb);
    this.scrollbarStateVertical = new StringScrollbarVertical(this.data, this.scrollbar, this.thumb);
    this.scrollbarState = this.scrollbarStateVertical;
  }

  private updateThumb() {
    this.scrollbarState.updateThumb();
  }

  private mouseDownEvent(e: MouseEvent) {
    this.isDragging = true;
    this.scrollbarState.mouseDownEvent(e);
    document.body.style.userSelect = 'none';
    this.scrollbar.classList.add('-touch');
  }

  private mouseMoveEvent(e: MouseEvent) {
    if (!this.isDragging) return;

    this.scrollbarState.mouseMoveEvent(e);
  }

  private mouseUpEvent() {
    this.isDragging = false;
    document.body.style.userSelect = '';
    this.hideScrollbar();
    this.scrollbar.classList.remove('-touch');
  }

  private showScrollbar() {
    this.scrollbar.classList.add('-scroll');
  }

  private hideScrollbar() {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      this.scrollbar.classList.remove('-scroll');
    }, 1000);
  }
}
